import { PushPin } from '@mui/icons-material';

const Pin = (): JSX.Element => <PushPin fontSize="inherit" />;

export default Pin;
